<template>
<div class="boxselector--outer">
        <h2>Valitse laatikon tyyppi</h2>
        <div class="boxselector">
            <div class="boxselector--cell" v-for="boxmodel in boxModels" :key="boxmodel" @click="selectBox(boxmodel)">
                <img :src="require(`@/assets/boxmodels/${boxmodel}.png`)" alt="boxmodel" />
                <p v-html="boxNames[boxmodel]"> Haijaa </p>
            </div>
    </div>
</div>
</template>

<script>
export default {
    name: "BoxSelector",
    props: {
        defaultBox: {
            defaul: 1,
        }
    },
    methods: {
      getPic(index) {
        //return '/assets/boxmodels/' + index + '.png';
        return require('../assets/'+index+'png');
      },
      selectBox(key) {
        //alert('Valitsit laatikon ' + key);
        //todo emit to parent so this will be hidden..
        this.$parent.model = key;
        this.$parent.modelName = this.boxNames[key];
      }
    },
    computed: {
    },
    mounted() {
    },
    data() {
    return {
        boxModels : [1,2,6
        ],
        boxNames : [
        '',/*reserved*/
        'Avoin laatikko',
        'Läpällinen laatikko',
        '...',
        '...',
        '...',
        'Kuplapussi',
        '...',
        '...',
        '...',
        ]
    }
    }
};
</script>

<style scoped lang="scss">

.boxselector--outer {
    display: block;
    width: 100%;
    background-color: #F6F6FF;
    min-height: 300px;
    overflow-y: scroll;
}
.boxselector {
    display: grid;
    place-items: center;
    grid-template-columns: repeat(auto-fit, minmax(192px, 1fr));
    grid-gap: 30px 10px;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.36px;
    color: #555555;
    &>.boxselector--cell {
        transition: all .2s ease-in-out;
        cursor: pointer;
        &:hover {
            outline: 2px solid #ffffff;
            box-shadow: 2px 2px 16px rgba(0, 0, 0, 0.2);
            filter: brightness(1.10);
            background-color: #ffffff;
            transform: translateY(-3px);
        }

        &>img {
            max-width: 100%;
        }
    }

}

</style>